/**
 * Hero slider — vanilla JS, brak zewnętrznych zależności.
 * Auto-rotate co 6s, pauza na hover, dots nav.
 */

export function initHeroSlider() {
    const slider = document.querySelector('[data-hn-hero-slider]');
    if (!slider) return;

    const slides = slider.querySelectorAll('[data-hn-hero-slide]');
    const dots = document.querySelectorAll('[data-hn-hero-dot]');
    if (slides.length < 2) return;

    let current = 0;
    let interval;
    const AUTO_DELAY = 6000;

    function show(index) {
        slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        current = index;
    }

    function next() {
        show((current + 1) % slides.length);
    }

    function start() {
        interval = setInterval(next, AUTO_DELAY);
    }

    function stop() {
        clearInterval(interval);
    }

    dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            show(i);
            stop();
            start();
        });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    start();
}
